import { render, staticRenderFns } from "./download-docs.vue?vue&type=template&id=7cd822b6&scoped=true"
import script from "./download-docs.vue?vue&type=script&lang=js"
export * from "./download-docs.vue?vue&type=script&lang=js"
import style0 from "./download-docs.vue?vue&type=style&index=0&id=7cd822b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd822b6",
  null
  
)

export default component.exports